import React, { Dispatch, SetStateAction } from 'react'
import { MedicalNoteDetailsContent } from './content'
import { Container, MessageError, LoadingContainer, SkeletonItem, ContentInLine } from './styles'
import { HealthProcedureDetails } from '../healthProcedureDetails'
import { ModalHeaderSkeleton } from '../ModalComponents/ModalHeader/Skeleton'
import { IHealthProcedures } from '~/interfaces'
import { useFetchMedicalNote } from '~/hooks'
import { DataNotFound } from '~/components/shared'

interface Props {
  healthProcedure: IHealthProcedures
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
}

export const MedicalNoteDetails = ({ healthProcedure, showModal, setShowModal }: Props): JSX.Element => {
  const {
    data: medicalNote,
    isLoading,
    error
  } = useFetchMedicalNote({
    pathParams: { noteId: healthProcedure.id }
  })

  const renderContent = () => {
    if (error)
      return (
        <MessageError>
          <DataNotFound text={error.message} />
        </MessageError>
      )
    if (isLoading) {
      return (
        <LoadingContainer>
          <ModalHeaderSkeleton />
          <SkeletonItem width={'100%'} height={'16px'} />
          <ContentInLine>
            <SkeletonItem width={'116px'} height={'16px'} />
            <SkeletonItem width={'204px'} height={'16px'} />
          </ContentInLine>
          <SkeletonItem width={'75%'} height={'16px'} />
          <SkeletonItem width={'92%'} height={'16px'} />
          <SkeletonItem width={'65%'} height={'16px'} />
        </LoadingContainer>
      )
    }
    if (medicalNote) return <MedicalNoteDetailsContent medicalNoteData={medicalNote} />
  }

  return (
    <HealthProcedureDetails showModal={showModal} setShowModal={setShowModal} viewType="SideModal">
      <Container>{renderContent()}</Container>
    </HealthProcedureDetails>
  )
}
